import React, { FunctionComponent } from 'react';
import { CircularProgress } from '@mui/material';
import cx from 'classnames';
import useStyles from './Spinner.styles';

interface IProps {
  show: boolean;
  size?: number;
  inline?: boolean;
}

const Spinner: FunctionComponent<IProps> = ({
  show = false,
  size = 80,
  inline,
}) => {
  const classes = useStyles();
  if (!show) {
    return null;
  }

  return (
    <div
      className={cx(classes.spinner, {
        [classes.spinnerInline]: inline,
      })}
    >
      <CircularProgress size={size} />
    </div>
  );
};

export default Spinner;
